<template>
    <svg width="7" height="12" viewBox="0 0 7 12" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.700781 11.2998C0.517448 11.1165 0.425781 10.8831 0.425781 10.5998C0.425781 10.3165 0.517448 10.0831 0.700781 9.8998L4.60078 5.9998L0.700781 2.0998C0.517448 1.91647 0.425781 1.68314 0.425781 1.3998C0.425781 1.11647 0.517448 0.883138 0.700781 0.699804C0.884114 0.516471 1.11745 0.424805 1.40078 0.424805C1.68411 0.424805 1.91745 0.516471 2.10078 0.699804L6.70078 5.2998C6.80078 5.3998 6.87178 5.50814 6.91378 5.6248C6.95511 5.74147 6.97578 5.86647 6.97578 5.9998C6.97578 6.13314 6.95511 6.25814 6.91378 6.3748C6.87178 6.49147 6.80078 6.5998 6.70078 6.6998L2.10078 11.2998C1.91745 11.4831 1.68411 11.5748 1.40078 11.5748C1.11745 11.5748 0.884114 11.4831 0.700781 11.2998Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default: 'none'
        }
    }
}
</script>